<template>
  <div class="container_error" :class="{error: fields[name].errorId}">
    <div class="editor">
      <textarea :id="editorId" :name="editorId"></textarea>
    </div>
    <div class="invalid_text">{{fields[name].errors[fields[name].errorId]}}</div>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from 'vuex'

  const {mapMutations, mapState} = createNamespacedHelpers('mainPage')

  export default {
    props: ['name', 'editorId'],
    data() {
      return {
        text: '',
      }
    },
    computed: {
      ...mapState([
        'fields'
      ])
    },
    methods: {
      ...mapMutations([
        'setField'
      ]),
    },
    mounted() {
      let editor = CKEDITOR.replace(this.editorId)
      if (this.fields[this.name].value) editor.setData(this.fields[this.name].value)
      this.setField({fieldId: this.name, fieldPropertyId: 'editor', value: editor})
    }
  }
</script>

<style scoped>
  .container_error.error {
    border: 1px solid;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/components/create-form/TextEditor.vue